import React from "react";
import './Production.css'
const ProductionCapacity = () => {
    const ProductionCapacityData = [
        {
            id:1,
            title:"Renewable Energy Capacity (Solar & Wind) (GW)",
            number1:"38.4",
            number2:"72.9",
            total:"111.3"
        },
        {
            id:2,
            title:"Hydrogen Production Capacity (mn tonnes/ year)",
            number1:"14.9",
            number2:"33",
            total:"47.9"
        },
        {
            id:2,
            title:"Green Fuel Production Capacity (mn tonnes/ year)",
            number1:"10.4",
            number2:"20.9",
            total:"31.2"
        },
    ]
    return(
        <div className="production-capacity-wrapper" id="production-capacity">
            <div className="production-capacity-wrapper-title">
            <div className='title-symbol production-capacity-symbol'>
                        <div className='page-symbole '></div>
                        <div className='title '> Production Capacity</div>
                    </div>
                 <div className="ctr">
                 <div className="production-capacity-data row ">
                        {ProductionCapacityData?.map(item => (
                            <div className="col-lg-4 col-md-4 col-12 mb-3 production-capacity-item-col" key={item?.id}>
                                <div className="production-capacity-item" >
                                    <h1>{item?.title}</h1>
                                </div>
                                <div className="capacity-numbers">
                                    <div className="number1">
                                        <div>{item?.number1}</div>
                                        <span>Pilot Phase</span>
                                        </div>
                                        <div className="number2">
                                        <div>{item?.number2}</div>
                                        <span>Phase 1</span>
                                        </div>
                                    </div>
                                    <hr/>
                                    <div className="capacity-total">
                                        <span>Total</span>
                                        <span>{item?.total}</span>
                                    </div>

                                   
                                </div>
                        ))}
                    </div>
                    <div className="usd-row row">
                    <div className="col-lg-4 col-md-4 col-12 mb-3 usd-item-col">
                        <h3>USD 53.9 bn</h3>
                        <h4>Pilot Phase Total Investment Cost</h4>
                    </div>
                    <div className="col-lg-4 col-md-4 col-12 mb-3 usd-item-col">
                        <h3>USD 118.3 bn</h3>
                        <h4>Phase 1 Total Investment Cost</h4>
                    </div>
                    <div className="col-lg-4 col-md-4 col-12 mb-3 usd-item-col">
                    <h3>USD 172.2 bn</h3>
                        <h4>All Phases: Total Investment</h4>
                    </div>
                    </div>
                 </div>
            </div>
        </div>
    )
}
export default ProductionCapacity